import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { addBrokerAsync, deleteBrokerAsync, getBrokerByIdAsync, getBrokersAsync, updateBrokerAsync } from './brokerThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const brokerSlice = createSlice({
    name: 'broker',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(addBrokerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(addBrokerAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(addBrokerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getBrokersAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getBrokersAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.brokers = action.payload;
        })
            .addCase(getBrokersAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getBrokerByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getBrokerByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.broker = action.payload;
        })
            .addCase(getBrokerByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateBrokerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateBrokerAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.broker = action.payload;
        })
            .addCase(updateBrokerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteBrokerAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteBrokerAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(deleteBrokerAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default brokerSlice.reducer;
